import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { addToWishlistAPI, removeFromWishlistAPI } from '../redux/store/wishlist';
import { toast } from 'react-toastify';
import { useAuth } from '../contexts/AuthContext';
import api from '../utilis/api';

const WishlistButton = ({ product, className = "", size = "md" }) => {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.user);
  const { wishlistItems } = useSelector((state) => state.wishlist);
  const { openLoginModal } = useAuth();
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Check if product is in wishlist
  useEffect(() => {
    if (isLoggedIn && wishlistItems) {
      const inWishlist = wishlistItems.some(
        item => item.product._id === product._id
      );
      setIsInWishlist(inWishlist);
    }
  }, [wishlistItems, product._id, isLoggedIn]);

  const handleWishlistClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!isLoggedIn) {
      openLoginModal();
      return;
    }

    setIsLoading(true);
    try {
      if (isInWishlist) {
        await dispatch(removeFromWishlistAPI(product._id)).unwrap();
        toast.success('Removed from wishlist', { autoClose: 2000 });
      } else {
        await dispatch(addToWishlistAPI(product._id)).unwrap();
        toast.success('Added to wishlist', { autoClose: 2000 });
      }
    } catch (error) {
      console.error('Wishlist error:', error);
      if (error.includes('Access denied') || error.includes('authentication token')) {
        // Token might be invalid, show login modal
        openLoginModal();
      } else {
        toast.error(error || 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const sizeClasses = {
    sm: "w-8 h-8 text-sm",
    md: "w-10 h-10 text-base", 
    lg: "w-12 h-12 text-lg"
  };

  return (
    <button
      onClick={handleWishlistClick}
      disabled={isLoading}
      className={`
        ${sizeClasses[size]} 
        rounded-full flex items-center justify-center transition-all duration-200
        ${isInWishlist 
          ? 'bg-red-100 text-red-500 hover:bg-red-200' 
          : 'bg-gray-100 text-gray-400 hover:bg-red-100 hover:text-red-500'
        }
        ${isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:scale-110'}
        ${className}
      `}
      title={isInWishlist ? 'Remove from wishlist' : 'Add to wishlist'}
    >
      {isLoading ? (
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
      ) : isInWishlist ? (
        <FaHeart />
      ) : (
        <FaRegHeart />
      )}
    </button>
  );
};

export default WishlistButton;